import React, { WheelEvent } from 'react';
// import { THICKNESS_CONTROLLER_NAMES } from '@constants/analysisModalConfig';
import Dropdown from '@components/Dropdown';
import CustomSlider from '@components/CustomSlider/CustomSlider';
import Button from '@components/Button';
import styles from './ThicknessContent.module.scss';

import { ThicknessMethodType } from 'config/analysisConfig';
import { THICKNESS_CONTROLLER_NAMES } from 'config/labels';
import { ThicknessMax, ThicknessStep } from 'config/panelConfig';

interface ThicknessContentProps {
  value: number;
  method: ThicknessMethodType;
  minValue: number;
  onChangeValue: (val: number) => void;
  onChangeMethod: (method: ThicknessMethodType) => void;
  onReset: ()=>void;
}

const ThicknessContent: React.FC<ThicknessContentProps> = ({
  value,
  method,
  minValue,
  onChangeValue,
  onChangeMethod,
  onReset,
}) => {
  return (
    <div className={styles.menuItemGroup}>
      <div className={styles.method}>
        <div className={styles.method_label}>
          <div className={styles.label}>
            <div className={styles.label_text}>
              {THICKNESS_CONTROLLER_NAMES.method}
            </div>
          </div>
        </div>
        <div className={styles.dropdown}>
          <Dropdown
            value={method}
            options={Object.entries(THICKNESS_CONTROLLER_NAMES.methods).map(
              ([key, label]) => ({ value: key, label: label as string }),
            )}
            onChange={(value: string) =>
              onChangeMethod(value as ThicknessMethodType)
            }
            className="font-dropdown"
          />
        </div>
      </div>
      <div className={styles.menuItem}>
        <div className={styles.thickness}>
          <div className={styles.labelInput}>
            <div className={styles.label}>
              <div className={styles.labelText}>
                {THICKNESS_CONTROLLER_NAMES.thickness}
              </div>
            </div>
            <Button className={styles.resetButton} onClick={onReset}>
              {THICKNESS_CONTROLLER_NAMES.reset}
            </Button>
          </div>
          <div className={styles.textInput}>
            <div className={styles.slidergrop}>
              <div
                className={styles.slider}
                onWheel={(e: WheelEvent) => {
                  if (e.deltaY === 0) return;
                  const newVal = Math.min(
                    ThicknessMax,
                    Math.max(
                      minValue,
                      value + Math.sign(-e.deltaY) * ThicknessStep,
                    ),
                  );
                  onChangeValue(newVal);
                }}
              >
                <CustomSlider
                  type="default"
                  value={value}
                  onChange={onChangeValue}
                  min={minValue}
                  max={ThicknessMax}
                  step={ThicknessStep}
                />
                <div className={styles.inputgrop} tabIndex={0}>
                  <div className={styles.input}>
                    <div className={styles.inputText}>
                      {Math.min(value, ThicknessMax).toFixed(1)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThicknessContent;
